export const tooltipContent = [
  {
    name: 'properties',
    title: `Properties`,
    body: `Total value of all properties you own, such as your house or apartment.`,
  },
  {
    name: 'life-policies',
    title: `Life Policies`,
    body: `Total value of all your life insurance policies including those that are going to pay directly to nominated beneficiaries as per policy documents.
    These policies attract estate duty in the estate even though they are paid by the insurer directly to the beneficiaries.`,
  },
  {
    name: 'vehicles',
    title: `Vehicles`,
    body: `Total value of vehicles you own, such as your cars, bikes, or trailers.`,
  },
  {
    name: 'other-assets',
    title: `Other Assets`,
    body: `Total value of any other assets, such as antiques, investments, art or jewelry.`,
  },
  {
    name: 'total-liabilities',
    title: `Total Liabilities`,
    body: `Total value of all your liabilities, such as car loans, home loans, credit cards and other debt.`,
  },

  {
    name: 'executor-fees',
    title: `Executor Fees`,
    body: `Fee paid to the executor for executing the will and managing asset distribution.`,
  },
  {
    name: 'masters-fees',
    title: `Master's Fees`,
    body: `Fees charged by the court for overseeing the administration of the estate.`,
  },
  {
    name: 'conveyancing-fees',
    title: `Conveyancing Fees`,
    body: `Legal fees paid when a property is transferred from one person to another.`,
  },
  {
    name: 'standard-administration-costs',
    title: `Standard Administration Cost`,
    body: `General expenses incurred in managed and settling the estate.`,
  },
  {
    name: 'estate-duty',
    title: `Estate Duty`,
    body: `Tax paid to South African Revenue Services on your passing.`,
  },
  {
    name: 'purchase-price',
    title: 'Purchase price',
    body: `Original purchase price.`,
  },
  {
    name: 'improvement-costs',
    title: 'Improvement costs',
    body: `These are costs for upgrades or improvements that increase the value of the asset. 
    This does not include maintenance or repairs.`,
  },
  {
    name: 'sale-price',
    title: 'Sale price',
    body: `Costs incurred during sale - automatically estimated if not provided.`,
  },
  {
    name: 'primary-residence',
    title: 'Primary residence',
    body: `Is this a primary residence?`,
  },
  {
    name: 'entity-type',
    title: 'Entity type',
    body: `Type of taxpayer.`,
  },
  {
    name: 'gross-annual-income',
    title: 'Gross annual income',
    body: `Taxpayer's taxable income (used for tax bracket determination)`,
  },
  {
    name: 'capital-gains-losses',
    title: 'Capital gains losses',
    body: `Previous capital losses carried forward`,
  },
];
